import { useEffect } from "react";
import { useState } from "react";

import { auth } from "../../lib/firebase";

import TextField from "../../components/textfield";
import Button from "../../components/button";

import Header from "../../components/header";

import { useNavigate } from "react-router-dom";

export default function ResetPassword() {

    const queryParameters = new URLSearchParams(window.location.search);
    const code = queryParameters.get("oobCode");

    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!code) {
            navigate("/");
        }
        document.title = 'Reset Password - Cognido';
      }, []);

    return (
        <div>
            
        </div>
    )
}